import React from "react";
import { v4 } from "uuid";
import SearchItemSkeleton from "./SearchItemSkeleton";
import SearchResultItem from "./SearchResultItem";

const SearchResults = ({ results, loading, viewmode }) => {
	return (
		<div className="columns is-multiline">
			{loading
				? new Array(12).fill(1).map((e) => {
						return <SearchItemSkeleton viewmode={viewmode} key={v4()} />;
				  })
				: (
                    results?.length > 0 ? results.map((result) => {
						return <SearchResultItem {...result} viewmode={viewmode} key={v4()} />;
				  }) : (
                    <div className="section-placeholder column is-vcentered is-6 is-centered"
                        style={{
                            margin: "auto",
                            marginTop: 200,
                        }}
                    >
                    <div className="placeholder-content search-engine">
                        <img
                            className="light-image"
                            src={
                                require("../../../assets/img/undraw_web_search_re_efla.svg")
                                    .default
                            }
                            alt=""
                            style={{ width: "100%" }}
                        />
                        <p>Search for your specialists</p>
                    </div>
                </div>
                  )
                )}
		</div>
	);
};

export default SearchResults;
